//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cms from '~/mixins/cms';

export default {
  cmsId: 'aircraft-and-packaging',
  name: 'aircraft-and-packaging',
  platforms: ['CABINET'],
  access: '*',
  mixins: [cms],
  computed: {
    title () {
      return this.content.heading;
    },
  },
  methods: {
    openParameters (aircraft) {
      this.$bus.$emit('open-media', {
        url: aircraft.parametersImage,
        type: 'image/jpeg',
        title: aircraft.name,
      });
    },
  },
};
